import React, { Component } from 'react';
import { createInputField, InputField } from 'redux-form-jsonschema-reactstrap'
import { injectSheet } from 'redux-form-jsonschema-reactstrap'

export function cif(_options) {
  const { styles, ...options } = _options;
  class CreatedInputField extends Component {
    render() {
      return <InputField {...this.props} {...options} />;
    }
  }

  return injectSheet(styles)(CreatedInputField);
}

export const InputCif = cif({ type: 'string'});

export const RequiredInput = cif({
  type: 'string',
  required: 'required'
});

export const NumberRangeRocker = cif({
  type: 'number',
  parse: value => {
    try {
      return parseInt(value)
    }
    catch (Exception) {
      return value;
    }
  },
  onkeydown: "return false",
});

export const DisabledText = createInputField({ type: 'text', disabled: true } );
